import React from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import OpenRoute from "./components/core/Auth/OpenRoute";
import PrivateRoute from "./components/core/Auth/PrivateRoute";
import { useSelector } from "react-redux";
import { ACCOUNT_TYPE } from "./data/constant";

// Components8
import Navbar from "./components/Navbar";

// pages
import Home from "./pages/Home";
import Login from "./pages/Login";
import Dashboard from "./components/core/dashboard/Dashboard";
import AddBook from "./components/core/dashboard/AddBook";
import AddStudent from "./components/core/dashboard/AddStudent";
import IssuedBook from "./components/core/dashboard/IssuedBook";
import AllBook from "./components/core/dashboard/AllBook";
import ReturnBook from "./components/core/dashboard/ReturnBook";
import AllStudents from "./components/core/dashboard/AllStudents";
import BookHistory from "./components/core/dashboard/BookHistory";
import OneStudent from "./components/core/dashboard/OneStudent";
import AddCategory from "./components/core/dashboard/AddCategory";
import ForgotPassword from "./pages/ForgotPassword";
import UpdatePassword from "./pages/UpdatePassword";
import Settings from "./components/core/dashboard/Settings/index";
import StudentTraniscation from "./components/core/dashboard/StudentTraniscation";
import Contact from "./pages/Contact";
import AboutUs from "./pages/AboutUs";
import DashboardMain from "./pages/DashboardMain";


function App() {
  const { user } = useSelector((state) => state.profile);

  return (
    <div className="min-h-screen w-screen  bg-pure-greys-50 ">
      <Navbar  />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<AboutUs />} />
     





        <Route
          path="/login"
          element={
            <OpenRoute>
              <Login />
            </OpenRoute>
          }
        />

        <Route
          path="/forgot-password"
          element={
            <OpenRoute>
              <ForgotPassword />
            </OpenRoute>
          }
        />

        <Route
          path="update-password/:id"
          element={
            <OpenRoute>
              <UpdatePassword />
            </OpenRoute>
          }
        />

        <Route
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        >
          <Route
            path="dashboard/all-book"
            element={
              <PrivateRoute>
                <AllBook />
              </PrivateRoute>
            }
          />

            <Route
            path="dashboard/setting"
            element={
              <PrivateRoute>
                <Settings />
              </PrivateRoute>
            }
          />

          {user?.accountType === ACCOUNT_TYPE.LIBRARIAN && (
            <>
            <Route path="dashboard/dashboard-main" element={<DashboardMain />} />
             
              <Route path="dashboard/add-book" element={<AddBook />} />
              <Route path="dashboard/add-student" element={<AddStudent />} />
              <Route path="dashboard/issued-book" element={<IssuedBook />} />
              <Route path="dashboard/return-book" element={<ReturnBook />} />
              <Route path="dashboard/all-student" element={<AllStudents />} />
              <Route
                path="dashboard/transication-book"
                element={<BookHistory />}
              />
              <Route
                path="dashboard/student/:studentId"
                element={<OneStudent />}
              />
              <Route path="dashboard/add-category" element={<AddCategory />} />
            </>
          )}

          {user?.accountType === ACCOUNT_TYPE.STUDENT && <>
            <Route path="dashboard/transication-book" element={<StudentTraniscation />} />
            <Route
                path="dashboard/student/:studentId"
                element={<OneStudent />}
              />

            
          </>}
        </Route>
      </Routes>
    </div>
  );
}

export default App;
